import { SidebarMenuBadge } from "@/components/ui/sidebar";
import { usePendingAttendance } from "../../hooks/use-pending-attendance";

export function PendingBadge() {
	const { data } = usePendingAttendance();
	const count = data?.count ?? 0;

	if (count === 0) return null;

	return (
		<SidebarMenuBadge
			className="pending-badge"
			data-count={count}
			aria-label={`${count} ${count === 1 ? "dia pendente" : "dias pendentes"} de ponto`}
		>
			{count}
		</SidebarMenuBadge>
	);
}
